import { DatastoreInterface } from '@freelancer/datastore/core';
import {
  CurrencyCode,
  generateCurrencyObject,
} from '../currencies/currencies.mock';
import { UserBalance } from './user-balances.model';
import { UserBalancesCollection } from './user-balances.types';

export async function createUserBalances(datastore: DatastoreInterface) {
  const objects = generateUserBalanceObjects();
  await Promise.all(
    objects.map(object =>
      datastore.createRawDocument<UserBalancesCollection>(
        'userBalances',
        object,
      ),
    ),
  );
  return objects;
}

function generateUserBalanceObjects(): ReadonlyArray<UserBalance> {
  return [
    {
      currency: generateCurrencyObject(CurrencyCode.USD),
      amount: 567,
      primary: true,
    },
  ].map(({ currency, amount, primary }) => ({
    id: currency.id,
    currency,
    amount,
    primary,
  }));
}
